// extracted by mini-css-extract-plugin
export default {"container":"AN-z","topReviewHeading":"BN-z","criticalReview":"CN-z","favorableReview":"DN-z","vsSeparator":"EN-z"};